/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Last_UpdatedInputs */

const es_tyc_last_updated = /** @type {(inputs: Tyc_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizacion: 16 de marzo de 2026`)
};

const en_tyc_last_updated = /** @type {(inputs: Tyc_Last_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: March 16, 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: March 16, 2026" |
*
* @param {Tyc_Last_UpdatedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_last_updated = /** @type {((inputs?: Tyc_Last_UpdatedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Last_UpdatedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_last_updated(inputs)
	return en_tyc_last_updated(inputs)
});
export { tyc_last_updated as "tyc.last_updated" }